import React, { useEffect, useState } from "react";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { baseURL } from "../../Util/axios_helper";
import { useDispatch, useSelector } from "react-redux";
import { getTourList, onMonthChange, onYearChange } from "./tour_slice";
import { KendoLoader } from "../../Kendo/kendo_loader";
import { KendoDropdown } from "../../Kendo/kendo_dropdown";

export const TourPage = () => {
  const [calendlyEvents, setCalendlyEvents] = useState([]);
  const [inquiryDetails, setInquiryDetails] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(0);
  const [selectedYear, setSelectedYear] = useState(0);
  const [months, setMonths] = useState([]);
  const [years, setYears] = useState([]);
  const[scheduledEventListData,setScheduledEventListData]=useState([])
  const [formattedDate, setformattedDate] = useState("");
  const dispatch = useDispatch();
  const { tourList, tourListLoaded, month, Year, refresh } = useSelector(
    (state) => state.tour
  );
  useEffect(() => {
    $('#events').addClass('active');
    return () => {
      $('#events').removeClass('active');
    };
  }, []);

  const handleEditClick = (e) => {
    try {
      e.month = month;
      e.Year = Year;

      dispatch(getTourList(e));
      $("#Tour_list").modal("show");
    } catch (error) {
      console.error("Error in handleEditClick", error);
    }
  };

  useEffect(() => {
    ScheduledEventData()
  }, [month, Year]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const monthOptions = Array.from({ length: 12 }, (_, index) => index + 1);
    const yearOptions = Array.from(
      { length: 10 },
      (_, index) => currentYear - index
    ); // Last 10 years
    setMonths(monthOptions);
    setYears(yearOptions);

    setSelectedMonth(currentMonth);
    setSelectedYear(currentYear);
    setformattedDate(
      `${currentYear}-${currentMonth
        .toString()
        .padStart(2, "0")}-01T00:00:00.000000Z`
    );
  
  }, []);

  const handleMonthChange = (event) => {
   
    dispatch(onMonthChange(event));
    // setSelectedMonth(event);
  };

  const handleYearChange = (event) => {
    dispatch(onYearChange(event));
    //setSelectedYear(event.target.value);
  };
  const ScheduledEventData = async () => {
    
    const res = await fetch(
      `${baseURL}ScheduledEventDetails/InquiryDetails?selectedMonth=${month}&selectedYear=${Year}`
    );
    const data = await res.json();
    
   setScheduledEventListData(data);
  };
  


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")}${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  };

  const columns = [
    {
      field: "start_time",
      title: "Start Time",
      template: ({ start_time }) => (start_time ? formatDate(start_time) : ""),
    },
    {
      field: "end_time",
      title: "End Time",
      template: ({ end_time }) => (end_time ? formatDate(end_time) : ""),
    },
    {
      field: "invitees",
      title: "Email",
      template: ({ invitees }) =>
        invitees && invitees.length > 0 ? invitees[0].email : "",
    },
    {
      field: "status",
      title: "Status",
    },
  ];

  return (
    <>
      <div className="page-header">
        <div className="row">
          <div className="col-sm-8">
            <h3 className="page-title">Tour List</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#">Template</a>
              </li>
              <li className="breadcrumb-item active">Tour List</li>
            </ul>
          </div>

          <div className="col-sm-2">
            {/* <select
              id="month"
              onChange={handleMonthChange}
              value={selectedMonth}
              className="btn  btn-xl dropdown-toggle pickers"
            >
              <option value="">Select Month</option>
              {months.map((month) => (
                <option key={month} value={month}>
                  {new Date(2022, month - 1, 1).toLocaleString("default", {
                    month: "long",
                  })}
                </option>
              ))}
            </select> */}

            <KendoDropdown
              id="month"
              name="month"
              data={months.map((month) => ({
                key: month,
                value: month,
                Month: new Date(2022, month - 1, 1).toLocaleString("default", {
                  month: "long",
                }),
              }))}
              //placeholder="Select Month"
              dataTextField="Month"
              dataValueField="value"
              value={month}
              onChange={handleMonthChange}
            />
          </div>
          <div className="col-sm-2">
            {/* <select
              id="year"
              onChange={handleYearChange}
              value={selectedYear}
              className="btn  btn-xl dropdown-toggle pickers"
            >
              <option value="">Select Year</option>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select> */}

            <KendoDropdown
              id="year"
              name="year"
              data={years.map((year) => ({
                key: year,
                value: year,
              }))}
              //placeholder="Select Year"
              dataTextField="value"
              dataValueField="value"
              value={Year}
              onChange={handleYearChange}
              className="btn btn-xl dropdown-toggle pickers"
            />
          </div>
        </div>
      </div>

      <div className="card bg-white">
        <div className="card-body">
          <div className="row">
            <KendoGrid
              name={"ScheduledEvent_List"}
             	data={scheduledEventListData}
              schema={{}}
              columns={[
                {
                  field: "InquiryId",
                  filterable: false,
                  hidden: true,
                },
                {
                  field: "FirstName",
                  title: "First Name",
                },
                {
                  field: "LastName",
                  title: "Last Name",
                },
                {
                  field: "EmailID",
                  title: "EmailID",
                },
                {
                  field: "EventType",
                  title: "EventType",
                },
              ]}
              showOptions={true}
              showEdit={true}
              showDelete={false}
              additionalFilters={{
                month: selectedMonth,
                year: selectedYear,
              }}
              onEditClick={handleEditClick}
              refreshWhen={refresh}
            />
          </div>
        </div>
      </div>
      {/* Tour List Modal */}
      <div className="modal custom-modal fade" id="Tour_list" role="dialog">
        <div
          className="modal-dialog modal-dialog-centered modal-xl"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Tour Booked List</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {tourListLoaded ? (
                <KendoGrid
                  name={"ScheduledEvent_List"}
                  data={tourList}
                  schema={{}}
                  columns={columns}
                />
              ) : (
                <KendoLoader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
